<script setup>
import { ref, onMounted } from 'vue';
import { getTable } from 'src/utils/common';
import { useIns } from 'src/utils/v2_helper/common';

const app = useIns();

const table = ref('');
onMounted(() => {
  table.value = getTable();
});
</script>
<template>
  <section class="table">
    <div class="table-tile">{{ $t('fullDinein.tablenumber') }}</div>
    <span class="table-content">{{ table }}</span>
  </section>
</template>
<style scoped lang="scss">
.m-tile {
  color: Black;
  font-weight: bold;
  font-size: 12px;
}
.table {
  padding: 16px;
  &-tile {
    @extend .m-tile;
    margin-bottom: 4px;
  }
}
</style>
